'use client'

import { Toaster as Sonner } from 'sonner'

import { useTheme } from '@app/_ThemeProvider'

type ToasterProps = React.ComponentProps<typeof Sonner>

const toastOptions: ToasterProps['toastOptions'] = {
  classNames: {
    toast: 'group toast group-[.toast]:shadow-lg group-[.toast]:!bg-card group-[.toast]:!border-border relative',
    description: 'group-[.toast]:text-muted-foreground',
    default: 'group-[.toast]:!text-foreground',
    actionButton: 'group-[.toast]:!bg-primary group-[.toast]:!text-primary-foreground',
    cancelButton: 'group-[.toast]:!bg-muted group-[.toast]:!text-muted-foreground',
    success:
      'group-[.toast]:!text-success group-[.toast]:!border-l-4 group-[.toast]:!border-l-success group-[.toast]:!shadow-md group-[.toast]:!shadow-success/25',
    info: 'group-[.toast]:!text-primary group-[.toast]:!border-l-4 group-[.toast]:!border-l-primary group-[.toast]:!shadow-md group-[.toast]:!shadow-primary/25',
    warning:
      'group-[.toast]:!text-warning group-[.toast]:!border-l-4 group-[.toast]:!border-l-warning group-[.toast]:!shadow-md group-[.toast]:!shadow-warning/25',
    error:
      'group-[.toast]:text-destructive-foreground! group-[.toast]:!border-l-4 group-[.toast]:!border-l-destructive-foreground group-[.toast]:!shadow-md group-[.toast]:!shadow-destructive-foreground/25',
  },
}

const SonnerToaster = ({ ...props }: ToasterProps) => {
  const { theme, isDarkOS } = useTheme()

  const getSonnerTheme = () => {
    if (theme === 'system') {
      return isDarkOS ? 'dark' : 'light'
    }

    return theme.startsWith('dark') ? 'dark' : 'light'
  }

  return (
    <Sonner
      richColors
      className='toast group'
      visibleToasts={10}
      gap={12}
      style={
        {
          '--z-index': '9999',
          pointerEvents: 'auto',
        } as React.CSSProperties
      }
      toastOptions={toastOptions}
      theme={getSonnerTheme()}
      {...props}
    />
  )
}

export { SonnerToaster }
